import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { OrderService } from 'src/app/data/order.service';
import { Filter } from 'src/app/models/common/filter';
import { OrdersDto } from 'src/app/models/dtos/orders/orders-dto';
import { IPagedResult } from 'src/app/shared/models/PagedResult';

interface PagingRequest {
  Page: number;
  PageSize: number;
  SortingDirection: string;
  SortingField: string;
}

@Injectable()
export class OrdersListDataSource extends DataSource<OrdersDto> {
  private orderService = inject(OrderService);

  public ordersSubject = new BehaviorSubject<OrdersDto[]>([]);
  private countSubject = new BehaviorSubject<number>(0);
  public count$ = this.countSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(true);
  public loading$ = this.loadingSubject.asObservable();


  constructor() {
    super();
  }

  connect(collectionViewer: CollectionViewer): Observable<OrdersDto[]> {
    return this.ordersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.ordersSubject.complete();
    this.loadingSubject.complete();
    this.countSubject.complete();
  }

  fetchOrders(
    page: number,
    count: number,
    sortingField: string,
    sortingDirection: string,
    filters: Filter[]
  ) {
    this.loadingSubject.next(true);
    const response$ = this.orderService
      .getOrders(page, count, sortingField, sortingDirection, filters)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )

    const orders$ = response$.pipe(map((response: IPagedResult<OrdersDto>) => response.Results));
    const count$ = response$.pipe(map((response: IPagedResult<OrdersDto>) => response.Count));

    orders$.subscribe(result => this.ordersSubject.next(result));
    count$.subscribe(count => this.countSubject.next(count));
  }
}